/** mini 时间轴容器宽度 单位：px */
export const MINI_WIDTH = 163;
/** 时间轴容器高度 单位：px */
export const TIME_LINE_HEIGHT = 64;
/** 播放、暂停图标容器宽度 单位：px */
export const PLAYER_ICON_WIDTH = 20;
/** 时间轴角半径 单位：px */
export const TIME_LINE_RADIUS = 2;
/** 伸缩图标容器宽度 单位：px */
export const PUSH_ICON_WIDTH = 36;
/** timeline 伸缩动画持续时间 单位：ms*/
export const TIME_LINE_FLEXIBLE_DURATION = 400;
/** 时间轴线左右两侧边距 */
export const DATE_LIST_PADDING = 24;
/** 下拉框最大高度 */
export const DROP_DOWN_BOX_HEIGHT = 280;
/** 下拉框单个框伸展动画持续时间 单位：ms*/
export const DROP_DOWN_SINGLE_DURATION = 100;
//# sourceMappingURL=config.js.map